import { isRouteErrorResponse, useRouteError } from "react-router";
import { Button } from "@/components/ui/controls";

/** Last-resort screen when a route throws while rendering. */
export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "An unexpected error stopped this screen.";
  return (
    <div
      role="alert"
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        background: "var(--bg)",
        color: "var(--ink)",
        padding: 24,
        textAlign: "center",
      }}
    >
      <h1 style={{ margin: 0, fontSize: 22, letterSpacing: "-0.02em" }}>
        This screen stopped working
      </h1>
      <p style={{ margin: 0, color: "var(--mut)", maxWidth: 460 }}>
        Reload to start it again. If it happens again, go to Home and tell whoever runs ZeaOps for
        your team what you were doing.
      </p>
      <p
        style={{
          margin: 0,
          color: "var(--fnt)",
          maxWidth: 460,
          fontFamily: "var(--mono)",
          fontSize: 12,
        }}
      >
        {message}
      </p>
      <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Button variant="field" onClick={() => window.location.assign("/")}>
          Go to Home
        </Button>
      </div>
    </div>
  );
}
